// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2cSyK","title":"ClientReferral_title__1IhGY","itemText":"ClientReferral_itemText__1hmVk"};